<div class="container">
    <img class="faqs-header-left" src="assets/merchant-landing-page/faq-header-left.png" />

    <img class="faqs-header-right" src="assets/merchant-landing-page/faq-header-right.png" />

  <div class="faqs-details">
    <h1>FAQs</h1>
    <div class="faqs-container-layout">
      <div class="faqs-left">
        <img src="assets/merchant-landing-page/faqs-left-icon.png" />
      </div>
      <div class="faqs-container container">
        <div *ngFor="let item of list">
          <div class="faqs-item">
            <h3>{{ item.title }}</h3>
            <p> {{ item.subtitle }}</p>
          </div>
        </div>
      </div>
      <div class="faqs-right">
        <img src="assets/merchant-landing-page/faqs-right-icon.png" />
      </div>
    </div>
  </div>
</div>
